import type React from 'react';

import { cn } from '@change/ds-utils';

import { useI18n } from '@change-corgi/core-react/i18n';

type Props = Readonly<{
	url: string;
	variation: 'variant_2' | 'variant_3';
}>;

export const DesktopShareAssetHeader: React.FC<Props> = ({ url, variation }) => {
	const { translate } = useI18n();

	return (
		<div className="relative -mb-4">
			<div
				data-qa="psf-share-desktop-asset-bg"
				className={cn('relative flex items-center justify-center rounded-t-xl pb-4 md:h-[19.57rem]', {
					'bg-white': variation === 'variant_2',
					'bg-[rgba(64,58,73,0.2)]': variation === 'variant_3',
				})}
			>
				<img src={url} alt={translate('corgi.psf.share.share_visual_preview_alt')} className="block w-80 rounded-lg" />
			</div>
		</div>
	);
};
